import { FC, memo } from "react";

const Play: FC = () => {
  return (
    <>
      <svg
        width="60"
        height="60"
        viewBox="0 0 60 60"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M30 0C13.4325 0 0 13.4325 0 30C0 46.5675 13.4325 60 30 60C46.5675 60 60 46.5675 60 30C60 13.4325 46.5675 0 30 0Z"
          fill="white"
        />
        <path
          opacity="0.8"
          d="M23.5524 15.319C24.1032 15.3075 24.6805 15.4461 25.2342 15.7579L43.0467 26.454C44.0179 27.0373 44.6811 28.1115 44.6811 29.3647C44.6811 30.6179 44.0179 31.6921 43.0467 32.2755L25.2342 42.9715C23.0166 44.2161 20.4821 42.6307 20.4258 40.0145V18.692C20.4672 16.7313 21.9032 15.3568 23.5524 15.3192V15.319Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default memo(Play);
